import { FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import css from './Breadcrumbs.module.css';
import { BreadcrumbItem } from '@shared/Interfaces/Navigation/BreadcrumbItem';

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items }) => (
    <nav aria-label="breadcrumb" className={css.container}>
        {items.map((item, idx) => {
            const isLast = idx === items.length - 1;
            const node = item.link ? (
                <Link
                    to={item.link}
                    onClick={item.onClick}
                    className={css.link}
                >
                    {item.label}
                </Link>
            ) : (
                <span onClick={item.onClick} className={css.item}>
                    {item.label}
                </span>
            );
            return (
                <div key={idx}>
                    {node}
                    {!isLast && <span className={css.divider}>/</span>}
                </div>
            );
        })}
    </nav>
);

export default Breadcrumbs;
